export const DEFERRED_REQUEST_KEYS = [
  'deliveryPickup',
  'discounts',
  'favorites',
  'ownerReviews',
  'pricing',
  'trades',
  'whyBuy'
] as const;

export type DeferredRequestKey = (typeof DEFERRED_REQUEST_KEYS)[number];
